import { render, staticRenderFns } from "./StandingAccountDetail.vue?vue&type=template&id=6a20eae9&scoped=true"
import script from "./StandingAccountDetail.vue?vue&type=script&lang=js"
export * from "./StandingAccountDetail.vue?vue&type=script&lang=js"
import style0 from "./StandingAccountDetail.vue?vue&type=style&index=0&id=6a20eae9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a20eae9",
  null
  
)

export default component.exports